// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_iy","advertCardFooter__row":"c-a_iz","advertCardFooter__name":"c-a_iA","advertCardFooter__price":"c-a_iB","advertCardFooter__age":"c-a_iC"};